import DBHandler from "../index-db/db-handler";
import { Clock_Settings, ActionLink } from "./class/coreSport";
import { ConfirmModel, Timestamp } from "../utils/utils";
import { SPORT_BASE, NAV_CONTROL, OVERLAY, SETTINGS, GLOBAL_VARS, SME_AUTH } from "../services/globalVars";
import WebSpeech from "../webSpeechAPI/webSpeech";
import LoginForm from "../../components/login-form/login-form";
import OverlaySlideMenu from "../../components/overlay-popup/overlay-slide-menu";
import ScoreTotals from "../../components/score-totals/score-totals";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import style from '../../style/share-style.module.scss';
import $ from 'jquery';
import { CAST_Rest_Clock, CAST_Update_Screen } from "../cast/cast-control";
import Sync from "../services/sync";
// import Auth from "../services/auth";
import { Wait_For_Auth, Logout, Sleep, DenySwalBox, ConfirmSwalBox, clearHotLoad, isHotLoad } from "../utils/utils";
import { TENNIS_SCORE_NAMES } from "../services/consts";
import { clear_hot_load } from "../utils/game-utils";
import { eventWrapper } from "@testing-library/user-event/dist/utils";

const speechObj = WebSpeech();
const dbHandler = DBHandler();


const build_sport_function = (args) => {
   // console.log('args: ', args)
   try {
      if (typeof args.length === 'undefined') {
         return convert_sport_function(args);
      } else {
         const funList = args.map(f => convert_sport_function(f));
         return () => {
            return new Promise(async (resolve) => {
               for (let a = 0; a < funList.length; a++) {
                  await funList[a]();
               }
               resolve(true);
            })
         }
      }
   } catch (error) {
      console.error('ERROR - build_sport_function: ', error)
      return false;
   }
}

const convert_sport_function = (args) => {
   // console.log('>>convert_sport_function :', args)
   if (args.type === 'null') { return () => { return new Promise((resolve) => { resolve(true) }) } }
   switch (args.type) {
      case 'score':
         return () => { return new Promise((resolve) => { resolve(trigger_score(args.value)) }) }
      case 'select_server':
         return () => { return new Promise((resolve) => { resolve(NAV_CONTROL.setServingPlayer(args.value)) }) }
      case 'startMatch':
         return startMatch
      case 'resumeMatch':
         return resumeMatch
      case 'setTimer':
         return () => { return new Promise((resolve) => { resolve(setTimer(args)) }) }
      case 'sideSwap':
         return sideSwap
      case 'screenFun':
         return () => { return new Promise((resolve) => { resolve(screenFun(args)) }) }
      case 'speechFun':
         return () => { return new Promise((resolve) => { resolve(speechFun(args)) }) }
      case 'completeMatch':
         return completeMatch
      case 'speech':
         return () => { 
            return new Promise(async (resolve) => {
               await speech(args.value, false); 
               await trigger_quick_sync('speechFun');
               resolve(true);
            });
         }
      case 'log':
         return async () => {
            const side = SPORT_BASE.sport_object.scoring.state.serving.side;
            switch (args.value) {
               case '(Stroke)':
                  const stroke_action = side === 1 ? 'p1stroke' : 'p2stroke';
                  SPORT_BASE.sport_object.scoring.state.match.active_game.add_log({
                     action: stroke_action,
                     content: 'stroke',
                     server_side: side,
                     score_side: side,
                  });
                  await SPORT_BASE.saveGameState('log-stroke');
                  await SPORT_BASE.updateGameStateTimestamp();
                  break;
               case '(Let)':
                  const Let_action = side === 1 ? 'p1let' : 'p2let';
                  SPORT_BASE.sport_object.scoring.state.match.active_game.add_log({
                     action: Let_action,
                     content: 'let',
                     server_side: side,
                     score_side: side,
                  });
                  await SPORT_BASE.saveGameState('log-let');
                  await SPORT_BASE.updateGameStateTimestamp();
                  break;
               case '(No Let)':
                  const no_Let_action = side === 1 ? 'p1nolet' : 'p2nolet';
                  SPORT_BASE.sport_object.scoring.state.match.active_game.add_log({
                     action: no_Let_action,
                     content: 'no let',
                     server_side: side,
                     score_side: side,
                  });
                  await SPORT_BASE.saveGameState('log-nolet');
                  await SPORT_BASE.updateGameStateTimestamp();
                  break;
               default:
                  break;
            }
         }
      case 'megaPhone_test':
         return megaPhoneTest
      case 'login':
         return open_login
      case 'logout':
         return logout
      case 'mute':
         return muteSound
      case 'sounds_test':
         return SoundsTest
      case 'Repeat':
         return repeatLastMessage
      case 'end_match':
         return endMatchPrompt
      case 'end_match_confirm':
         return endMatchConfirm
      case 'score_undo':
         return score_undo
      case 'save_serving_defaults':
         return save_serving_defaults
      case 'update_game_state_timestamp':
         return update_game_state_timestamp
      case 'change_device_reg':
         return change_device_reg
      case 'change_sport_reg':
         return change_sport_reg
      case 'clear_database':
         return clear_database
      case 'clean_last_message':
         return clean_last_message
      case 'add_10_points_continuous':
         return add_10_points_continuous
      case 'reverse_score_continuous':
         return reverse_score_continuous
      case 'free_app_status':
         return free_app_status
      case 'swap_score_screen':
         return swap_score_screen
      case 'nav':
         return () => { return new Promise((resolve) => { resolve(nav_control(args)) }) }
      case 'sub_menu':
         return () => { return new Promise((resolve) => { resolve(sub_menu(args)) }) }
      case 'cast_btn':
         return () => Promise.resolve(true)
      case 'confirm_box_confirm':
         return () => { return new Promise((resolve) => { resolve(ConfirmSwalBox()) }) }
      case 'confirm_box_deny':
         return () => { return new Promise((resolve) => { resolve(DenySwalBox()) }) }
      default:
         console.error(`build_sport_function Error: ${args.type} Not Implemented`);
         console.log('args: ', args);
         return () => { return new Promise((resolve) => { resolve(console.error('Not Implemented')) }) }
   }
}


const is_active_match = (id) => {
   return new Promise(async (resolve) => {
      try {
         const app_state = await dbHandler.load_app_state();
         if (app_state) {
            if (app_state.match_id === id) {
               resolve(true);
               return;
            }
         }

         resolve(false);
      } catch (error) {
         console.error('Error is_active_match: ', error);
         resolve(false);
      }
   });
}

const clear_database = () => {
   return new Promise(async (resolve) => {
      const result = await ConfirmModel({
         title: `Clear Database`,
         text: `Clearing the database will log you out and remove all match data. Are you sure you want to proceed?`,
         confirmButtonText: 'Yes',
         showCancelButton: true,
         allowOutsideClick: true,
      });
      if (result.isConfirmed) {
         Logout();
      }
   });
}

const trigger_score = (side) => {
   return new Promise(async (resolve) => {
      // console.log('>>> trigger_score: ', side);
      // console.log('>>> trigger_score : ', SPORT_BASE.sport_object.scoring.scoring);
      const result = await SPORT_BASE.sport_object.scoring.scoring.score({ side });
      // console.log('>>> trigger_score - result: ', result);
      await SPORT_BASE.saveGameState('trigger_score');
      NAV_CONTROL.refreshScore('trigger_score()');
      dbHandler.update_app_state({ update: Timestamp() });
      resolve(result);
   });
}

const change_sport_reg = () => {
   return new Promise(async (resolve) => {
      try {
         const active_match_id = SPORT_BASE.sport_object.scoring.state.match.id;
         const loaded_match = await SPORT_BASE.loadMatch(active_match_id);
         if (loaded_match.match_state !== 'match_won') {
            const end_match_result = await endMatchPrompt();
            if (end_match_result === false) {
               resolve(false);
               return;
            }
         }
         await Wait_For_Auth(SME_AUTH);
         SME_AUTH.is_authenticated().then(async (authResult) => {
            const syncObj = new Sync(SME_AUTH, {});
            // >>> What for sme_con         
            while (!syncObj.sme_con.ready) {
               if (syncObj.sme_con.client === false) {
                  resolve(false);
                  return
               }
               await Sleep(50);
            }
            const select_sport_result = await syncObj.select_sport();
            console.warn('[DEBUG] change_sport_reg - select_sport_result: ', select_sport_result);
   
            if (select_sport_result) {
               const settings = await dbHandler.load_settings();
   
               if (settings) {
                  const sport_type = settings.sport;
                  const update_club_ads_result = await syncObj.update_club_ads(sport_type);
                  console.log('update_club_ads -- update_club_ads_result: ', update_club_ads_result);
               }
            }
            console.log('Lets Fix here???');
   
            window.location.reload();
            resolve(true);
         });
      } catch (error) {
         console.error('Error change_sport_reg: ', error);
         resolve(false);
      }
   });
}

const change_device_reg = () => {
   return new Promise(async (resolve) => {
      await Wait_For_Auth(SME_AUTH);
      SME_AUTH.is_authenticated().then(async (authResult) => {
         const syncObj = new Sync(SME_AUTH, {});
         // >>> What for sme_con         
         while (!syncObj.sme_con.ready) {
            if (syncObj.sme_con.client === false) {
               resolve(false);
               return
            }
            await Sleep(50);
         }
         await syncObj.register_device(true);
         window.location.reload();
      });
   });
}

const endMatchConfirm = () => {
   return new Promise(async (resolve) => {
      const score_1 = SPORT_BASE.sport_object.scoring.scoring.team_1_score.value;
      const score_2 = SPORT_BASE.sport_object.scoring.scoring.team_2_score.value;

      if (score_1 === score_2) {
         ConfirmModel({
            title: `Winner is needed`,
            text: ``,
            confirmButtonText: 'Yes',
            showCancelButton: true,
            showConfirmButton: false,
            allowOutsideClick: false,
         });
         return
      }
      const result = await ConfirmModel({
         title: `Game Completed`,
         text: `Are you sure?`,
         confirmButtonText: 'Yes',
         showCancelButton: true,
         allowOutsideClick: false,
         confirm_button_delay: 3
      });
      if (result.isConfirmed) {
         if (score_1 > score_2) {
            SPORT_BASE.sport_object.scoring.scoring.set_winner_manual(1);
         } else if (score_1 < score_2) {
            SPORT_BASE.sport_object.scoring.scoring.set_winner_manual(2);
         }
         
         const match = SPORT_BASE.sport_object.scoring.state.match;
         await SPORT_BASE.saveMatch(match.id, match, 'endMatchConfirm');
         await SPORT_BASE.saveGameState('match_complete');
         dbHandler.update_app_state({ update: Timestamp(), game_state: 'match_complete', });

         await endGame();
      }
      resolve(true);
   });
}

const update_game_state_timestamp = () => {
   return new Promise((resolve) => {
      SPORT_BASE.updateGameStateTimestamp();
      resolve(true);
   });
}

const speech_translate = (text_key, value) => {
   const speech = SPORT_BASE.store_sport_config.speech;
   // console.log('speech_translate: ', speech[text_key]);
   const raw_text = JSON.parse(JSON.stringify(speech[text_key]));

   if (raw_text !== false) {
      const text = raw_text.replace(/<#X#>/g, value);
      return text;
   } else {
      return '';
   }
}

const speech = (text, save = true, voice_on = true, forceSync = true) => {
   return new Promise(async (resolve) => {
      const game_count = SPORT_BASE.sport_object.scoring.state.match.games.length;
      if (voice_on) {
         if (GLOBAL_VARS.free_app === false || game_count === 1) {
            // const speechObj = WebSpeech();
            await speechObj.text_to_speech(text, forceSync);
         }
      }
      if (save === true) {
         if (!(GLOBAL_VARS.free_app === false || game_count === 1)) {
            text = text + "  (Free App) Sound Disabled";
         }
         await dbHandler.saveSettings({
            last_message: text,
         });
      }
      resolve(true);
   });
}

const update_cast_settings = () => {
   return new Promise(async (resolve) => {
      try {
         if (typeof SPORT_BASE?.sport_object?.scoring?.state?.match?.cast_data?.speech_text !== 'undefined') {
            const cast_data = SPORT_BASE.sport_object.scoring.state.match.cast_data;
            // console.log('update_cast_settings - cast_data: ', JSON.parse(JSON.stringify( cast_data )));
            // console.log('update_cast_settings - SETTINGS: ', JSON.parse(JSON.stringify( SETTINGS )));
            cast_data.background = SETTINGS.background;
            cast_data.cast_border_size = SETTINGS.cast_border_size;
            cast_data.cast_speech_rate = SETTINGS.cast_speech_rate;
            cast_data.cast_voice = SETTINGS.cast_voice;
            cast_data.mute = SETTINGS.mute;

            

            
            // console.log('update_cast_settings - trigger_quick_sync');
            // await SPORT_BASE.saveActiveMatch();
            // await trigger_quick_sync('update_cast_settings');
            // await trigger_quick_sync('update_cast_settings');
         }
         
         resolve(true);
      } catch (error) {
         console.error('Error update_cast_settings: ', error);
         resolve(false);
      }
   });
}

const trigger_quick_sync = (caller = '') => {
   return new Promise(async (resolve) => {
      try {
         // console.warn('>>> trigger_quick_sync: ', caller);
         // OLD: GLOBAL_VARS.matched_changed = performance.now();
         // CRITICAL FIX: Save to DB BEFORE triggering sync to prevent race condition
         // This ensures the DB has the latest data before the sync process reads from it
         await SPORT_BASE.saveGameState('trigger_quick_sync');
         await SPORT_BASE.updateGameStateTimestamp();
         GLOBAL_VARS.syncTrigger?.trigger(caller); // Trigger sync AFTER data is saved
         resolve(true);
      } catch (error) {
         console.error('Error trigger_quick_sync: ', error);
         resolve(false);
      }
   });
}
   
const reverse_score_continuous = () => {
   return new Promise(async (resolve) => {
      const team_1_score = SPORT_BASE.sport_object.scoring.state.match.active_game.team_1_score;
      const team_2_score = SPORT_BASE.sport_object.scoring.state.match.active_game.team_2_score;
      const log_data = {
         team_1_score: team_1_score,
         team_2_score: team_2_score,
      }
      const side = SPORT_BASE.sport_object.scoring.state.serving.side;
      const Let_action = side === 1 ? 'p1swap' : 'p2swap';


      SPORT_BASE.sport_object.scoring.state.match.active_game.team_1_score = team_2_score;
      SPORT_BASE.sport_object.scoring.state.match.active_game.team_2_score = team_1_score;
      SPORT_BASE.sport_object.scoring.state.match.active_game.add_log({
         action: Let_action,
         content: 'swap-score',
         server_side: side,
         score_side: side,
         data: log_data,
      });

      await SPORT_BASE.saveGameState('reverse_score_continuous');
      NAV_CONTROL.refreshScore();
      dbHandler.update_app_state({ update: Timestamp() });

      resolve(true);
   });
}

const add_10_points_continuous = () => {
   return new Promise(async (resolve) => {
      const team_1_score = SPORT_BASE.sport_object.scoring.state.match.active_game.team_1_score;
      const team_2_score = SPORT_BASE.sport_object.scoring.state.match.active_game.team_2_score;

      if (team_1_score > team_2_score) {
         await SPORT_BASE.sport_object.scoring.scoring.score({ side: 2, points: 10 });
      } else if (team_1_score < team_2_score) {
         await SPORT_BASE.sport_object.scoring.scoring.score({ side: 1, points: 10 });
      }

      await SPORT_BASE.saveGameState('add_10_points_continuous');
      NAV_CONTROL.refreshScore();
      dbHandler.update_app_state({ update: Timestamp() });
      resolve(true);
   });
}

const clean_last_message = () => {
   return new Promise(async (resolve) => {
      dbHandler.saveSettings({
         last_message: '+--CLEAR--+',
      }).finally(async () => {
         await dbHandler.update_app_state({ update: Timestamp() });
         resolve(true);
      });
   });
}

const repeatLastMessage = () => {
   return new Promise(async (resolve) => {
      if (SETTINGS.last_message === '+--CLEAR--+') {
         resolve(true);
         return;
      }
      await speech(SETTINGS.last_message, false);
      resolve(true);
   });
}

const save_serving_defaults = () => {
   return new Promise(async (resolve) => {
      const manual_log = SPORT_BASE.sport_object.scoring.state.serving.manual_change_log;
      for (let a = 0; a < manual_log.length; a++) {
         SPORT_BASE.sport_object.scoring.state.serving.player_defaults[manual_log[a].player] = manual_log[a].inner_side;
      }
      SPORT_BASE.sport_object.scoring.state.serving.manual_change_log = [];
      SPORT_BASE.sport_object.scoring.state.serving.manual_change = false;
      await SPORT_BASE.saveGameState('save_serving_defaults');
      await SPORT_BASE.updateGameStateTimestamp();

      ConfirmModel({
         title: `Side Saved`,
         text: ``,
         confirmButtonText: 'Close',
         showCancelButton: false,
         allowOutsideClick: true,
         timer: 3000,
         timerProgressBar: true,
      });

      resolve(true);
   });
}

const score_undo = () => {
   return new Promise(async (resolve) => {

      SPORT_BASE.sport_object.scoring.scoring.undo();
      await speech('undo', false); 
      await trigger_quick_sync('score_undo - speech');
      
      
      await SPORT_BASE.saveGameState('score_undo');
      NAV_CONTROL.refreshScore();
      dbHandler.update_app_state({ update: Timestamp() });
     
      trigger_quick_sync('score_undo');
      resolve(true);
   });
}

const sub_menu = (args) => {
   if (typeof OVERLAY !== 'undefined') {
      if (OVERLAY.sts === 0) {
         const optionList = args.options.map(i => {
            return {
               jsx: new ActionLink(i.jsx),
               fun: build_sport_function(i.fun),
            }
         })
         OVERLAY.element((<OverlaySlideMenu hide={OVERLAY.hide} options={optionList} ></OverlaySlideMenu>));
         OVERLAY.show();
      }
   }
}

const nav_control = (args) => {
   return new Promise((resolve) => {
      console.log('>>> nav_control: ', args);
      switch (args.value) {
         case 'open_right_menu':
            NAV_CONTROL.openRightMenu();
            break;
         case 'open_scoresheet':
            NAV_CONTROL.openRightMenuScoresheet();
            break;
         default:
            break;
      }
      resolve(true);
   });
}

const SoundsTest = () => {
   return new Promise(async (resolve) => {
      await speech('Scoring Made Easy, Sound Check', false);
      resolve(true);
   });
}


const open_login = () => {
   console.log('>>> loginTest <<<');
   if (typeof OVERLAY !== 'undefined') {
      console.log('sts: ', OVERLAY.sts);
      if (OVERLAY.sts === 0) {
         OVERLAY.element((<LoginForm commonTriggers={OVERLAY} ></LoginForm>));
         OVERLAY.show();
      }
   }
}

const logout = () => {
   console.log('Called Logout......');
   Logout();
}

const swap_score_screen = () => {
   return new Promise(async (resolve) => {
      SPORT_BASE.sport_object.scoring.scoring.toggle_side_swap();
      await SPORT_BASE.saveGameState('swap_score_screen');
      dbHandler.update_app_state({ update: Timestamp() });
      NAV_CONTROL.refreshScore();
      resolve(true);
   });
}



const free_app_status = () => {
   // console.log('>>> free_app_status <<<: ', GLOBAL_VARS);
   if (typeof GLOBAL_VARS !== 'undefined') {
      return GLOBAL_VARS.free_app;
   }
   return true;
}

const megaPhoneTest = () => {
   console.log('navigator: ', navigator)
   if (navigator.mediaDevices) {
      navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
         handlerFunction(stream)
      }).then(() => {
         record();
         const MySwal = withReactContent(Swal)
         MySwal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Record Start',
            showConfirmButton: false,
            timer: 1500
         })

         setTimeout(function () {
            stop_record();
            const MySwal = withReactContent(Swal)
            MySwal.fire({
               position: 'top-end',
               icon: 'success',
               title: 'Record End',
               showConfirmButton: false,
               timer: 1500
            })
         }, 3000);
      });
   } else {
      const MySwal = withReactContent(Swal)
      MySwal.fire({
         position: 'top-end',
         icon: 'Error',
         title: 'No media Devices found',
         showConfirmButton: false,
         timer: 1500
      })
   }

   console.log($('.audioPlayer'))
   const recordedAudio = $('.audioPlayer').eq(0);
   var audioChunks = [];
   var rec;

   function handlerFunction(stream) {
      rec = new MediaRecorder(stream);
      rec.ondataavailable = e => {
         audioChunks.push(e.data);
         if (rec.state === "inactive") {
            let blob = new Blob(audioChunks, { type: 'audio/mpeg-3' });
            console.log('recordedAudio: ', recordedAudio)
            // console.log('recordedAudio: ', $(recordedAudio).attr())
            recordedAudio.attr('src', URL.createObjectURL(blob));
            recordedAudio.attr('controls', true);
            recordedAudio.attr('autoplay', true);

            // recordedAudio.src = URL.createObjectURL(blob);
            // recordedAudio.controls = true;
            // recordedAudio.autoplay = true;
            sendData(blob)
         }
      }
   }
   function sendData(data) { }

   const record = () => {
      console.log('Start record');
      audioChunks = [];
      rec.start();
   }
   const stop_record = () => {
      rec.stop();
      console.log('Stop record');
   }
}

const setTimer = (args) => {
   return new Promise(async (resolve) => {
      let result;
      const clockIndex = SPORT_BASE.sport_object.clocks.findIndex(clock => clock.id === args.value.id);
      if (clockIndex !== -1) {
         if (typeof args.value.init_value !== 'undefined' && args.value.init_value !== null) {
            const init_value = args.value.init_value;
            if (init_value.type === 'game_setting') {
               const linkedSetting = SPORT_BASE.sport_object.get_setting_by_key(init_value.value);
               const newTime = linkedSetting.value * 60;
               args.value.value = newTime;
            }
         }

         const newClock = new Clock_Settings(args.value);
         newClock.state = 0;
         SPORT_BASE.sport_object.clocks[clockIndex] = newClock;
         await SPORT_BASE.saveClock(newClock);
         dbHandler.update_app_state({ update: Timestamp() });
         setTimeout(async function () {
            newClock.state = 1;
            result = newClock;
            SPORT_BASE.sport_object.clocks[clockIndex] = newClock;
            await SPORT_BASE.saveClock(newClock);
            dbHandler.update_app_state({ update: Timestamp() });
            resolve({ type: 'setTimer', value: result });
         }, 100);
      } else {
         resolve({ type: 'setTimer', value: result });
      }
   });
}

const stopClock = async (type) => {
   return new Promise(async (resolve) => {
      const clockIndex = SPORT_BASE.sport_object.clocks.findIndex(clock => clock.id === type);
      if (clockIndex !== -1) {
         const clock = SPORT_BASE.sport_object.clocks[clockIndex];
         clock.state = 0;
         SPORT_BASE.sport_object.clocks[clockIndex] = clock;
         await SPORT_BASE.saveClock(clock);
      }
      resolve({ type: 'stopClock', value: type });
   });
}

const getClockTime = async (type) => {
   return new Promise(async (resolve) => {
      const clockIndex = SPORT_BASE.sport_object.clocks.findIndex(clock => clock.id === type);
      if (clockIndex !== -1) {
         const clock = SPORT_BASE.sport_object.clocks[clockIndex];
         resolve(clock.value);
      }
      resolve(0);
   });
}

const stopAllClocks = () => {
   return new Promise(async (resolve) => {
      for (let a = 0; a < SPORT_BASE.store_sport_config.clocks.length; a++) {
         await stopClock(SPORT_BASE.store_sport_config.clocks[a].id);
      }
      resolve(true);
   });
}




const refresh_page_fix = () => {
   return new Promise(async (resolve) => {
      try {
         if (false) { // Change to true to enable page refresh
            await Sleep(50);
            window.location.reload();
         }
         resolve(true);
      } catch (error) {
         resolve(true);
      }
   });
}

const resumeMatch = () => {
   return new Promise(async (resolve) => {
      await stopAllClocks();
      NAV_CONTROL.killClocks();

      console.log('>>> resumeMatch <<<');
      const gameClock = 'game_clock';
      const clockIndex = SPORT_BASE.sport_object.clocks.findIndex(clock => clock.id === gameClock);
      if (clockIndex !== -1) {
         const game_clock = SPORT_BASE.sport_object.clocks[clockIndex];
         await setTimer({ value: game_clock });
      }
      
      // await setTimer({ value: game_clock });


      
      
      await dbHandler.update_app_state({ update: Timestamp(), game_state: 'running', });
      SPORT_BASE.sport_object.scoring.state.match.active_game.set_state(1); // Set Active game state to running
      await SPORT_BASE.saveGameState('endGame');
      await clean_last_message();
      NAV_CONTROL.refreshScore('resumeMatch');

      await refresh_page_fix();
     
   });
}

const startMatch = () => {
   return new Promise(async (resolve) => {
      let new_game = false;
      await stopAllClocks();
      NAV_CONTROL.killClocks();

      // console.error('Start Match');

      SPORT_BASE.sport_object.scoring.scoring.update_match_state('running');
      if (SPORT_BASE.sport_object.game_state === 'game_complete') {
         new_game = true;
         // console.log('>>>---+ Start New Game ************');
         SPORT_BASE.sport_object.scoring.state.match.add_game();
         SPORT_BASE.sport_object.scoring.state.match.active_game.set_state(1);
         SPORT_BASE.sport_object.scoring.state.setup_config = SPORT_BASE.fresh_setup_config();
         SPORT_BASE.sport_object.scoring.state.serving.refresh_player();
      } else {
         console.warn('===STARTING NEW MATCH===');
         // check_matches_for_errors();
      }

      // >>> Sets Player Serving settings
      const server_player = SPORT_BASE.sport_object.scoring.state.serving.player;
      const player_default = SPORT_BASE.sport_object.scoring.state.serving.player_defaults[server_player];
      if (SPORT_BASE.sport_object.scoring.state.serving.player_defaults[server_player] !== null) {
         SPORT_BASE.sport_object.scoring.serving.update_serve({ inner_side: player_default });
      } else {
         SPORT_BASE.sport_object.scoring.serving.update_serve({ inner_side: 2 });
      }

      // console.error('Start Match - after serving update');
      // console.log('game_state: ', SPORT_BASE.sport_object.game_state);
      // console.log('sport_name: ', SPORT_BASE.sport_object.sport_name);


      // console.log('SPORT_BASE.sport_type: ', SPORT_BASE.sport_type);
      // if (SPORT_BASE.sport_type) {
      //    SPORT_BASE.sport_object.scoring.serving.update_serve({ serving_player: 2 });
      // }

      await SPORT_BASE.saveGameState('startMatch');

      // >>> Reset and Save Clocks
      SPORT_BASE.sport_object.init_self_clocks(SPORT_BASE.store_sport_config.clocks);
      for (let a = 0; a < SPORT_BASE.sport_object.clocks.length; a++) {
         await SPORT_BASE.saveClock(SPORT_BASE.sport_object.clocks[a])
      }

      if (SPORT_BASE.check_continuous_clock()) {
         console.log('START MATCH - continuous_clock');
         const continuous_clock = SPORT_BASE.getClock('continuous_clock');
         console.log('START MATCH - continuous_clock', continuous_clock);
         setTimer({ value: continuous_clock });
      }

      const gameClock = 'game_clock';
      const clockIndex = SPORT_BASE.sport_object.clocks.findIndex(clock => clock.id === gameClock);
      if (clockIndex !== -1) {
         const game_clock = SPORT_BASE.sport_object.clocks[clockIndex];
         await setTimer({ value: game_clock });
      }

      if (SPORT_BASE.sport_object.game_state === 'warmup') {
         await dbHandler.update_app_state({ update: Timestamp(), game_state: 'server_select', });
         if (SPORT_BASE.sport_object.sport_name === 'Tennis' || SPORT_BASE.sport_object.sport_name === 'Padel') {
            speechFun({ value: 'play_button_tennis', text_only: true })
         } else if (SPORT_BASE.sport_object.sport_name === 'Tennis' || SPORT_BASE.sport_object.sport_name === 'Padel') {
            speechFun({ value: 'play_button', text_only: true })
         }
      } else if (SPORT_BASE.sport_object.sport_name === 'Pickleball') { // Change this to a value that lives in the sport-json
         console.error('>>> startMatch - Pickleball <<< - server_select');
         await dbHandler.update_app_state({ update: Timestamp(), game_state: 'server_select', })
      }  else {
         await dbHandler.update_app_state({ update: Timestamp(), game_state: 'running', });
         await clean_last_message();
      }

      stopClock('warmup_timer');
      NAV_CONTROL.refreshScore('startMatch()');

      await Sleep(1000);
      CAST_Rest_Clock();
      await refresh_page_fix();


      if (new_game) {
         SPORT_BASE.sport_object.scoring.scoring.flush_state();
         await trigger_quick_sync('startMatch - flush_state');
      }
      

      resolve({ type: 'startMatch', value: '' });
   });
}

const endMatchPrompt = (allow_close = true) => {
   return new Promise(async (resolve) => {
      console.error('endMatchPrompt - allow_close: ', allow_close);
      const playerObj = SPORT_BASE.sport_object.get_player_settings();
      const playerColor = playerObj.Match_Players.color_table;
      const teamA_name = playerObj.Match_Players.teams[0].name;
      const teamB_name = playerObj.Match_Players.teams[1].name;
      const teamA_color = playerColor[0];
      const teamB_color = playerColor[1];
      const winnerResult = await ConfirmModel({
         title: `Choose Winner`,
         text: ``,
         width: '98%',
         html: (<div className={style.chooseWinnerBox}> <ScoreTotals></ScoreTotals> </div>),
         confirmButtonText: teamA_name,
         denyButtonText: teamB_name,
         confirmButtonColor: teamA_color,
         denyButtonColor: teamB_color,
         showCancelButton: false,
         allowOutsideClick: allow_close,
         showCloseButton: allow_close,
         showDenyButton: true,
      });

      if (winnerResult.isConfirmed) {
         SPORT_BASE.sport_object.scoring.scoring.set_winner_manual(1);
      } else if (winnerResult.isDenied) {
         SPORT_BASE.sport_object.scoring.scoring.set_winner_manual(2);
      } else if (winnerResult.isDismissed && (winnerResult.dismiss === 'cancel' || winnerResult.dismiss === 'close' || winnerResult.dismiss === 'backdrop')) {
         resolve(false);
         return
      }

      SPORT_BASE.sport_object.scoring.scoring.match_won = true;
      const match = SPORT_BASE.sport_object.scoring.state.match;

      // console.log('endMatchPrompt - matchmatch.id: ', match.id);

      await SPORT_BASE.saveMatch(match.id, match, 'endMatchPrompt');
      // await SPORT_BASE.saveGameState('match_complete');
      // await SPORT_BASE.saveActiveMatch();

      NAV_CONTROL.appliedDefaultSettings();
      await dbHandler.update_app_state({ update: Timestamp(), game_state: 'match_complete', });
      await endGame();


      resolve(true);
   });
}

const endGame = () => {
   return new Promise(async (resolve) => {
      SPORT_BASE.sport_object.scoring.state.match.active_game.set_state(2); // Set Active game state to completed
      await SPORT_BASE.saveGameState('endGame');
      stopClock('game_clock');
      await clean_last_message();

      const active_match_id = SPORT_BASE.sport_object.scoring.state.match.id;
      const loaded_match = await SPORT_BASE.loadMatch(active_match_id);

      // console.log('endGame - active_match_id: ', active_match_id);
      // console.log('loaded_match: ', loaded_match);

      // if (SPORT_BASE.sport_object.scoring.scoring.match_won) {
      if (loaded_match.match_state === 'match_won') {
         // console.log('endGame - match_won');
         await endMatch();
      }
      
      // await trigger_quick_sync('endGame'); // This caused a game Wont instead of a match_won.......

      resolve({ type: 'endGame', value: '' });
   });
}

const waitForMatchSync = (match_id, timeout = 60_000) => {
   return new Promise(async (resolve) => {
      let match = null;
      const startTime = Date.now();
      
      do {
         match = await dbHandler.loadMatch(match_id);
         await Sleep(100);
         
         // Check if timeout has been exceeded
         if (Date.now() - startTime > timeout) {
            console.warn(`waitForMatchSync - timeout exceeded for match_id: ${match_id}`);
            resolve(false);
            break;
         }
         
         const synced = match.synced === 1;
         console.log('waitForMatchSync - synced: ', synced);
      } while (match !== null && match.synced !== 1);
      
      console.log('waitForMatchSync - -match: ', match);

      resolve(true);
   });
}


const endMatch = () => {
   return new Promise(async (resolve) => {
      try {
         // console.log('>>> endMatch <<<', isHotLoad());
         if (isHotLoad()) {
            let hit_error = false
            let hit_error_error = ''

            const result = await ConfirmModel({
               title: 'Syncing Match',
               text: 'Waiting for match to finished syncing...',
               confirmButtonText: 'Yes',
               denyButtonText: 'No',
               allowOutsideClick: false,
               showCancelButton: false,
               showConfirmButton: false,
               showDenyButton: false,
               showLoaderOnConfirm: true,
               preConfirm: async (result) => {
                  try {
                     // console.log('\n\n >>> preConfirm <<<  [START]\n\n');
                     const matches = await dbHandler.loadAllMatches();
                     // console.log('matches: ', matches);
                     for (let index = 0; index < matches.length; index++) {
                        const match = matches[index];
                        const synced = await waitForMatchSync(match.id, 120_000);
                        if (!synced) {
                           console.error('waitForMatchSync - match not synced: ', match.id);
                        } else {
                           console.log('waitForMatchSync - match synced: ', match.id);
                           // await dbHandler.deleteMatch(match.id);
                        }
                     }

                     await clear_hot_load();
                     
                     // await dbHandler.delete_account();
                     // await dbHandler.delete_club();
                     // await dbHandler.delete_sync();
                     // await dbHandler.delete_app_state();
                     
                     // console.log('\n\n >>> preConfirm <<<  [END]\n\n');

                     return true;
                  } catch (error) {
                     console.error('ERROR - endMatch preConfirm: ', error);
                     hit_error_error = error;
                     hit_error = true;
                     return true;
                  }
               },
               didOpen: () => {
                  // Force confirm immediately on open
                  Swal.clickConfirm();
               }
            })

            console.log('\n\n >>> result <<<  [END]\n\n');
            console.log('result: ', result);
            console.log('result: ', result.value);
            console.log('hit_error: ', hit_error);
            // await Sleep(25000);

            if (hit_error) {
               await ConfirmModel({
                  icon: 'error',
                  title: 'Sync Error',
                  text: `Please reset browser cache or contact support. Error: E01\n\n${hit_error_error}`,
                  confirmButtonText: 'OK',
                  showCancelButton: false,
                  allowOutsideClick: false,
               });
            } else {
               await ConfirmModel({
                  icon: 'success',
                  title: 'Sync Complete',
                  text: 'App State will now reset',
                  confirmButtonText: 'OK',
                  showCancelButton: false,
                  allowOutsideClick: false,
               });
            }
            



           
            
            // Reload the page to reset the app to its original state

            await clearHotLoad();
            window.location.reload();
         }
      
         
         resolve({ type: 'endMatch', value: true });
      } catch (error) {
         console.error('ERROR - endMatch: ', error);
         resolve({ type: 'endMatch', value: false });
      }
   });
}


const killMatchCheck = () => {
   return new Promise(async (resolve) => {
      try {
            console.error('Match Killed!');
            console.log('SPORT_BASE: ', SPORT_BASE.sport_object.app_state);

            SPORT_BASE.sport_object.scoring.state.match.match_state = "match_won"
            SPORT_BASE.sport_object.scoring.state.match.winner = 10;
            SPORT_BASE.sport_object.scoring.state.match.synced = 1;
            await SPORT_BASE.saveGameState('killMatchCheck');
            await SPORT_BASE.updateGameStateTimestamp();
            
            await dbHandler.update_app_state({ app_state: 'init', game_state: 'init', match_id: 0 }, 'initMatch');
            await clearHotLoad();

            // await SPORT_BASE.saveGameState();
            // await SPORT_BASE.updateGameStateTimestamp();

            await ConfirmModel({
               icon: 'warning',
               title: 'Match Stopped',
               text: 'Match has been stopped by Admin',
               confirmButtonText: 'OK',
               showCancelButton: false,
               allowOutsideClick: false,
            });
           
            resolve({ type: 'killMatchCheck', value: true });
      } catch (error) {
         console.error('ERROR - killMatchCheck: ', error);
         resolve({ type: 'killMatchCheck', value: false });
      }
   });
}


const completeMatch = async () => {
   return new Promise(async (resolve) => {
      await dbHandler.update_app_state({ update: Timestamp(), app_state: null, game_state: null, });
      NAV_CONTROL.appliedDefaultSettings();
      setTimeout(() => {
         NAV_CONTROL.appliedDefaultSettings();
      }, 500);
      NAV_CONTROL.openMainMenuNew();
      resolve({ type: 'completeMatch', value: '' });
   });
}

const screenFun = (args) => {
   return new Promise(async (resolve) => {
      console.log('>>> screenFun - Clicked <<<', args);
      switch (args.value) {
         case "warmup":
            await dbHandler.update_app_state({ game_state: 'warmup' });
            break;
         default:
            break;
      }
      resolve({ type: 'screenFun', value: '' });
   });
}

const speechFun = (args) => {
   return new Promise(async (resolve) => {
      console.log('>>> speechFun - Clicked <<<', args);
      switch (args.value) {
         case 'game_start':
            const winBy = SPORT_BASE.sport_object.scoring.get_setting({ setting_name: 'win_by' }).value;
            const pointTxt = winBy > 1 ? 'points' : 'point';
            const text = `Players to win by ${winBy} ${pointTxt}`;
            if (typeof args.text_only !== 'undefined' && args.text_only === true) {
               speech(text, true, false);
            } else {
               speech(text);
            }
            break;
         case 'play_button':
            {
               let text = '';
               if (SPORT_BASE.sport_object.scoring.state.match.games.length === 1) {
                  const match_options = SPORT_BASE.sport_object.scoring.state.match.settings.match_options;
                  if (match_options === "2") {
                     const continuous_time = SPORT_BASE.sport_object.scoring.state.match.settings.continuous_time;
                     text = `Playing continuous scoring for ${continuous_time} minutes`;
                  } else {
                     const games = SPORT_BASE.sport_object.scoring.state.match.settings.games_per_match;
                     const points = SPORT_BASE.sport_object.scoring.state.match.settings.points_per_game;
                     text = `Playing ${points} points, best of ${games} games`;
                  }
               } else {
                  const side = SPORT_BASE.sport_object.scoring.state.serving.side;
                  const { team1, team2 } = SPORT_BASE.sport_object.scoring.scoring.get_score_tally;
                  if (team1 === team2) {
                     if (team1 === 1) {
                        text = `${team1}! Game all! !`;
                     } else {
                        text = `${team1}! Games all! `;
                     }
                  } else if (side === 1) {
                     text = `${team1}! Games to ${team2} !`;
                  } else if (side === 2) {
                     text = `${team2}! Games to ${team1} !`;
                  }
               }

               if (typeof args.text_only !== 'undefined' && args.text_only === true) {
                  speech(text, true, false);
               } else {
                  speech(text);
               }
            }
            break;
         case 'play_button_tennis':
            {
               let text = '';
               if (SPORT_BASE.sport_object.scoring.state.match.games.length === 1) {
                  const match_options = SPORT_BASE.sport_object.scoring.state.match.settings.match_options;
                  if (match_options === "3") {
                     const continuous_time = SPORT_BASE.sport_object.scoring.state.match.settings.continuous_time;
                     text = `Playing continuous scoring for ${continuous_time} minutes`;
                  } else if (match_options === "2") {
                     const pb_points = SPORT_BASE.sport_object.scoring.state.match.settings.pb_points
                     text = `Playing to ${pb_points} points`;
                  } else {
                     const sets = SPORT_BASE.sport_object.scoring.state.match.settings.games_per_match;
                     const games = SPORT_BASE.sport_object.scoring.state.match.settings.points_per_game;
                     text = `Playing ${games} games, best of ${sets} sets`;
                  }
               } else {
                  const side = SPORT_BASE.sport_object.scoring.state.serving.side;
                  const { team1, team2 } = SPORT_BASE.sport_object.scoring.scoring.get_score_tally;
                  if (team1 === team2) {
                     if (team1 === 1) {
                        text = `${team1}! Game all! !`;
                     } else {
                        text = `${team1}! Games all! `;
                     }
                  } else if (side === 1) {
                     text = `${team1}! Games to ${team2} !`;
                  } else if (side === 2) {
                     text = `${team2}! Games to ${team1} !`;
                  }
               }

               if (typeof args.text_only !== 'undefined' && args.text_only === true) {
                  speech(text, true, false);
               } else {
                  speech(text);
               }
            }
            
            break;
         case 'start_match':
            {
               const winBy = SPORT_BASE.sport_object.scoring.get_setting({ setting_name: 'win_by' }).value;
               const gamesPerMatch = SPORT_BASE.sport_object.scoring.get_setting({ setting_name: 'games_per_match' }).value;
               const pointTxt = winBy > 1 ? 'points' : 'point';
               const gamesTxt = gamesPerMatch > 1 ? 'games' : 'game';
               const text = `Players to win by ${winBy} ${pointTxt} best of ${gamesPerMatch} ${gamesTxt}`;

               if (typeof args.text_only !== 'undefined' && args.text_only === true) {
                  speech(text, true, false);
               } else {
                  speech(text);
               }
            }
            break;
         default:
            break;
      }
      resolve({ type: 'speechFun', value: '' });
   });
}

const sideSwap = (value) => {
   return new Promise(async (resolve) => {
      // console.log('>>> changeSides <<<', NAV_CONTROL.state);
      speech('Please change sides');
      resolve({ type: 'sideSwap', value: '' });
   });
}

const muteSound = () => {
   return new Promise((resolve) => {
      const value = SETTINGS.mute === true ? false : true;
      SETTINGS.mute = value;
      dbHandler.saveSettings({
         mute: value,
      });

      if (GLOBAL_VARS.cast_running) {
         CAST_Update_Screen();
      }

      resolve(true);
   });
}


const is_push_match = () => {
   // console.error('\n\n >>> is_push_match: <<<<');
   // console.log('SPORT_BASE.sport_object.scoring.state.match: ', typeof push_match);
   // console.log('SPORT_BASE.sport_object.scoring.state.match: ', push_match);


   const push_match = SPORT_BASE.sport_object.scoring.state.match.push_match;
   if (push_match.load_mid === 0 &&
      push_match.tc_id === 0 &&
      push_match.t_id === 0 &&
      push_match.match_type === '' &&
      push_match.group_name === '') {
      return false;
   } else {
      return true;
   }
}



const get_pre_score = () => {  
   let is_pre_score = false;
   let left_pre = null;
   let right_pre = null;
   let mainScoreVisible = true;
   const scoring = SPORT_BASE.sport_object.scoring;

   const deciding_match = scoring.get_setting({ setting_name: 'deciding_match' })?.value;
   const per_point_scoring = scoring.get_setting({ setting_name: 'per_point_scoring' })?.value;
   const is_deciding_match = scoring.scoring?.deciding_match;

   // console.log('is_deciding_match: ', is_deciding_match);
   // console.log('deciding_match: ', deciding_match);
   // console.log('scoring.scoring.team_1_score_pre: ', scoring.scoring.team_1_score_pre);
   // console.log('scoring.scoring.team_2_score_pre: ', scoring.scoring.team_2_score_pre);
   // console.log('scoring.scoring.is_set_tie_break(): ', scoring.scoring.is_set_tie_break());

   if (is_deciding_match && deciding_match === 2) {
      mainScoreVisible = false;
      left_pre = scoring.scoring.team_1_score_pre?.value;
      right_pre = scoring.scoring.team_2_score_pre?.value;
   } else if (typeof scoring.scoring.is_set_tie_break == 'function' && scoring.scoring.is_set_tie_break()) {
      left_pre = scoring.scoring.team_1_score_pre?.value;
      right_pre = scoring.scoring.team_2_score_pre?.value;
   } else if (per_point_scoring === 1) {
      left_pre = TENNIS_SCORE_NAMES[scoring.scoring.team_1_score_pre?.value];
      right_pre = TENNIS_SCORE_NAMES[scoring.scoring.team_2_score_pre?.value];
      is_pre_score = true;
   }

   // console.log('get_pre_score - left_pre: ', left_pre);
   // console.log('get_pre_score - right_pre: ', right_pre);
   // console.log('get_pre_score - mainScoreVisible: ', mainScoreVisible);
   // console.log('get_pre_score - is_pre_score: ', is_pre_score);

   return { left_pre, right_pre, mainScoreVisible, is_pre_score };
}

export {
   build_sport_function,
   endMatchPrompt,
   stopAllClocks,
   endGame,
   stopClock,
   speech,
   speech_translate,
   getClockTime,
   SoundsTest,
   update_game_state_timestamp,
   open_login,
   free_app_status,
   is_push_match,
   clean_last_message,
   get_pre_score,
   endMatch,
   killMatchCheck,
   update_cast_settings,
   trigger_quick_sync,
   is_active_match
};